import { ResourceModel, format_useLabel } from '@modules/resource/resource.module'

import timesheetStatuses from '@server/constants/statuses/timesheet-statuses'

const TimesheetModel = new ResourceModel({
	resourceKey: 'timesheet',
}, [
	{
		key: 'status',
		label: 'Status',
		type: 'select',
		fieldProps: {
			options: timesheetStatuses.map(status => ({
				label: status.label,
				value: status,
			})),
		},
		defaultValue: timesheetStatuses.find(s => s.key === 'live').order, // TODO: see if .order is required here
		toCSV: {
			formatValue: val => val && val.label,
		}
	},
	{
		key: 'weekEnding',
		label: 'Week Ending',
		type: 'date',
	},
	{
		key: 'client',
		type: 'object',
		label: 'Client',
		children: [
			{
				key: 'clientID',
				label: 'Client ID',
				type: 'text',
			},
			{
				key: 'clientName',
				label: 'Client Name',
				type: 'text',
			},
			{
				key: 'consultant',
				label: 'Assigned Consultant',
				type: 'resourceSelect',
				readOnly: true, // TODO: handle readOnly
				toCSV: {
					formatValue: format_useLabel,
				}
			},
		],
	},
	{
		key: 'taxWeek',
		label: 'Tax Week',
		type: 'number',
	},
	{
		key: 'totalHours',
		label: 'Hours Worked',
		type: 'number',
		readOnly: true,
	},
	{
		key: 'totalCost',
		label: 'Total Cost',
		type: 'number',
		readOnly: true,
	},
	// TODO: add timesheetLines
])

// TODO: remove window instances after development
window.TimesheetModel = TimesheetModel;

export default TimesheetModel


// WEBPACK FOOTER //
// ./src/modules/timesheet/timesheet.model.js